/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IHeiProductIncludedViewProps } from './hei-product-included';
import InnerHTML from 'dangerously-set-html-content';

export default (props: IHeiProductIncludedViewProps) => {
    const {
        data: { productInfo, product },
        config: { heading },
        resources
    } = props;

    const html = productInfo.result?.IncludedHtml;

    if (!html) {
        return null;
    }

    const itemId = product?.result?.ItemId;
    const isUsedGood = itemId && (itemId.startsWith('Z') || itemId?.startsWith('U'));

    return (
        <div className='hei-product-included section-container'>
            {heading?.text && <Msdyn365.Text className='section-container-heading' tag={heading.tag ?? 'h2'} text={heading.text} />}
            {!isUsedGood && <InnerHTML html={html} />}
            {isUsedGood && <p className='hei-used-good-disclaimer'>{resources.usedGoodDisclaimer}</p>}
        </div>
    );
};
